@if (showBgImg) {
  <ng-container *observe="employerLogo$ as erLogoData; before: loadingLogoTemplate; error: errorTemplate">
    @if (erLogoData.image) {
      <img [src]="erLogoData.image" alt="Employer Logo" class="logo custom"/>
    } @else {
      <img src="assets/images/stiira_logo.svg" alt="Stiira Logo" class="logo" width="140px" />
    }
  </ng-container>
}

<!-- main: the signed-out pages' main landmark (signed-in pages get theirs from app.component) -->
<main class="outlet" *observe="data$ as data; before: loadingTemplate; error: errorTemplate">
  @if (showBgImg) {
    <router-outlet></router-outlet>
  }
</main>

<ng-template #loadingLogoTemplate>
  <mat-spinner class="logo" color="accent" [diameter]="40"></mat-spinner>
</ng-template>

<ng-template #loadingTemplate>
  <div class="outlet spinner-container">
    <mat-spinner color="accent" [diameter]="40"></mat-spinner>
  </div>
</ng-template>

<ng-template #errorTemplate></ng-template>
